export const routesApp = {
  root: "/",
  terms_conditions: "/terms-and-conditions",
  privacy: "/privacy-policy",
  error404: "*",
};
